import { ZoomImageContainer } from 'shared/components/Parameters';
import Layout from '../../components/mainPage/Layout';
import image from '../../images/OPCUAServer.svg'
export const Page = () => {
  return (
    <Layout>
      <div className="container">
        <div className="article-container w-100">
          <h1>
            OPC UA Сервер
          </h1>
          <p>
            OPC UA Server в SCADA NPT — это "универсальный поставщик" для предоставления данных по правилам OPC UA.
          </p>
          <p>
            SCADA NPT с OPC UA Server становится источником данных для других систем. Она говорит: "У меня есть вся информация о процессе, и я готова предоставлять её всем желающим в стандартном, понятном виде, по правилам OPC UA".
          </p>

          <div className="m-1" style={{ float: 'right' }}>
            <div style={{ maxWidth: '500px' }}>
              <ZoomImageContainer
                image={image}
              />
            </div>
          </div>
          <div>
            <h2>
              Задачи OPC UA Server в SCADA:
            </h2>
            <h3>
              1. Интеграция с системами верхнего уровня (MES, ERP)
            </h3>
            <p>
              SCADA управляет технологическим процессом, но данные о производстве (например, выпуск продукции, расход сырья, простои оборудования) нужны также и бизнес-системам.
            </p>
            <ul>
              <li>
                MES (Manufacturing Execution System) может через свой OPC UA Client подключиться к SCADA-серверу и в реальном времени забирать данные для построения отчетов OEE, управления качеством и диспетчеризации.
              </li>
              <li>
                ERP (Enterprise Resource Planning) может получать актуальные данные о выпуске продукции для обновления складских остатков и планирования заказов.
              </li>
            </ul>



            <p>
              SCADA с OPC UA Server становится надежным и стандартизированным мостом между цехом и офисом.
            </p>
            <h3>
              2. Создание единой точки доступа к данным
            </h3>
            <p>
              На предприятии может быть несколько SCADA-систем от разных производителей, отвечающих за разные участки или разные уровни управления (энергетика, водоподготовка, основное производство). Вместо того чтобы подключаться к каждой из них по своему протоколу, можно:
            </p>
            <ul>
              <li>
                Назначить одну из SCADA (или отдельный сервер) главным агрегатором данных с OPC UA Server.
              </li>
              <li>
                Другие SCADA-системы (выступая как OPC UA Clients) передают в него свои данные.
              </li>
              <li>
                Все внешние системы (MES, BI, облака) подключаются только к этому единому OPC UA Server, чтобы получить консолидированную картину по всему предприятию. Это упрощает архитектуру и повышает безопасность.
              </li>
            </ul>
            <h3>
              3. Взаимодействие между SCADA-системами
            </h3>
            <p>
              Бывают случаи, когда одна SCADA должна "узнать", что происходит в другой. Например, SCADA основного производства должна получать данные от SCADA энергоузла о параметрах пара или напряжения. OPC UA — идеальный стандартизированный способ организовать этот обмен.
            </p>
            <h3>
              4. Предоставление данных для систем аналитики и IoT-платформ
            </h3>
            <p>
              Современные системы анализа данных (Big Data, AI), панели управления в стиле Business Intelligence (BI) и промышленные IoT-платформы (например, MindSphere, Predix) часто используют OPC UA в качестве основного протокола для сбора данных с "поля". SCADA NPT, выступая в роли OPC UA Server, становится для них легальным и структурированным источником высококачественных данных.
            </p>
            <h3>
              5. Резервирование и распределенные архитектуры
            </h3>
            <p>
              В распределенных системах SCADA-сервер с OPC UA Server может работать в паре с другим, резервным сервером. Резервный сервер (используя свой OPC UA Client) может подписываться на данные основного, чтобы всегда иметь актуальную копию данных для быстрого переключения при сбое.
            </p>
            <h3>
              6. Семантическое информационное моделирование
            </h3>
            <p>
              SCADA NPT, выступая как OPC UA Server, может предоставлять данные не просто как набор тегов (Temp1, Pressure2), а как богатую информационную модель.
            </p>
            <p>Вместо плоского списка она может предоставить объект Насос_А101, который будет иметь:</p>
            <ul>
              <li><strong>Свойства:</strong> Модель, ЗаводскойНомер, ДатаВводаВЭксплуатацию.</li>
              <li><strong>Переменные:</strong> Температура, Ток, Статус.</li>
              <li><strong>Методы:</strong> Запустить, Остановить, ЗапроситьДиагностику.</li>
            </ul>
            <p>
              Это кардинально упрощает интеграцию для систем верхнего уровня, так как они "понимают" смысл данных, а не просто работают с сырыми значениями.
            </p>
            <p>
              <strong>Наличие OPC UA Server в SCADA NPT — это признак зрелой, открытой и интегрируемой системы.</strong> Это позволяет SCADA NPT не быть "тупиком" для данных, а стать полноправным участником корпоративной информационной экосистемы, легко и безопасно обмениваясь данными с любыми системами, поддерживающими мировой стандарт OPC UA. В современных условиях SCADA система должна уметь не только собирать данные, но и грамотно их отдавать, что и обеспечивает OPC UA Server встроенный в SCADA NPT.
            </p>
          </div>
          <div style={{ clear: 'both' }}></div>
        </div>
      </div>
    </Layout>

  );
};

export const meta = {
  title: 'OPC UA Сервер',
  description: 'OPC UA Server в SCADA NPT — это "универсальный поставщик" для предоставления данных по правилам OPC UA.'
}